export const gigyaLogin = (url, implementationCode, locale) => {
  // TODO: url and implementationCode should be cleaned up.
  var params = {
    screenSet: "Passport-RegistrationLogin",
    startScreen: "gigya-login-screen",
    containerID: "userScreensDiv",
    lang: locale,

    onAfterSubmit: function (evt) {
      /* Mute logging.
      console.log("Custom onAfterSubmit");
      console.log(evt);
      console.log(evt.form);
      */
      if ((evt.form === 'gigya-login-form' || evt.form === 'gigya-profile-form') && evt.response.errorCode === 0) {
        window.gigya.accounts.getJWT({
          fields: 'firstName,lastName,email',
          expiration: 604800,
          callback: function (resp) {
            after_jwt_cb(evt, resp);
          }
        });
      }
    }
  };
  console.log(window, params);
  window.gigya.accounts.showScreenSet(params);
};

export const loadScriptAsync = (uri) => {
  return new Promise((resolve, reject) => {
    let tag = document.createElement('script');
    tag.src = uri;
    tag.async = true;
    tag.onload = () => {
      resolve();
    };
    document.body.appendChild(tag);
  });
};

export const gigyaPasswordReset = (url, implementationCode, locale) => {
  // TODO: url and implementationCode should be cleaned up.
  var params = {
    screenSet: "Passport-RegistrationLogin",
    startScreen: "gigya-reset-password-screen",
    containerID: "userScreensDiv",
    lang: locale,

    onAfterSubmit: function (evt) {
      if (evt.form === 'gigya-reset-password-form' && evt.response.errorCode === 0) {
        window.gigya.accounts.getJWT({
          fields: 'firstName,lastName,email',
          expiration: 604800,
          callback: function (resp) {
            after_password_reset(evt, resp);
          }
        });
      }
    }
  };
  window.gigya.accounts.showScreenSet(params);
};

var after_jwt_cb = function (evt, resp) {
  /* Mute logging.
  console.log("after_jwt_cb");
  console.log(evt);
  console.log(resp);
  console.log(evt.response);
  console.log(resp.id_token);
  */
  var u = document.querySelectorAll("#signin-form input[name=email]")[0];
  u.value = evt.response.profile.email;
  var p = document.querySelectorAll("#signin-form input[name=password]")[0];
  p.value = resp.id_token;

  // The following lines are all in the name of keeping your browser from trying to save the token as your password.
  p.readOnly = true;
  p.setAttribute('autocomplete', 'off');
  p.setAttribute('type', 'hidden');
  var f = document.querySelectorAll("form")[0];
  f.setAttribute('autocomplete', 'off');

  var s = document.getElementById("signin-submit");
  s.click();
};

var after_password_reset = function (evt, resp) {
  /* Mute logging.
  console.log(evt);
  console.log(resp);
  */
};



// WEBPACK FOOTER //
// ./src/client/pages/auth/gigya.js